import { useEffect, useState } from 'react';

// The phone layout's breakpoint, the same 767px the stylesheet's phone block
// uses (GRAVY-10991). The CSS handles the look; this is for the few things CSS
// cannot do: pinning the calendar to the Day view and rendering the day strip.
export const PHONE_QUERY = '(max-width: 767px)';

const read = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(PHONE_QUERY).matches
    : false;

const useIsPhone = () => {
  const [isPhone, setIsPhone] = useState(read);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;
    const media = window.matchMedia(PHONE_QUERY);
    const update = () => setIsPhone(media.matches);
    update();
    // A rotated phone or a resized window crosses the breakpoint without a
    // reload. `addEventListener` is missing on older Safari's MediaQueryList.
    if (media.addEventListener) {
      media.addEventListener('change', update);
      return () => media.removeEventListener('change', update);
    }
    media.addListener(update);
    return () => media.removeListener(update);
  }, []);

  return isPhone;
};

export default useIsPhone;
